<template>
  <v-flex 
    md12 
    class="flex_container">
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-flex 
            xs3 
            md2>
            <v-avatar
              :size="imageSize"
              class="d-flex"
              style="margin-left: auto; margin-right: auto;"
              color="grey lighten-4">
              <v-img 
                :src="experience.logo" 
                contain/>
            </v-avatar>
            <div>
              <dl>
                <dd class="caption">{{ $t("from_date") }}</dd>
                <dt>{{ experience.from }}</dt>
                <dd class="caption">{{ $t("to_date") }}</dd>
                <dt>{{ experience.to }}</dt>
              </dl>
            </div>
                
          </v-flex>
          <v-flex 
            xs9 
            md10>
            <p class="title">{{ experience.position }}</p>
            <p class="subheading">{{ experience.business }}</p>
            <p class="body-2">{{ $t("responsibilities") }}:</p>

            <ul class="normal-list">
              <li 
                v-for="responsibility in experience.responsibilities" 
                :key="responsibility.id">{{ responsibility.text }}</li>
            </ul>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<style lang="scss" scoped>
.flex_container {
  page-break-inside: avoid;
  break-inside: avoid;
}
</style>

<script>
export default {
    name: 'ExperienceItem',
    props: {
        experience: {
          type: Object,
          default: null
        }
    },
    data () {
        return {
        }
    },
    computed: {
        imageSize() {
            return (this.$vuetify.breakpoint.lgAndUp) ? "7vw" :
                (this.$vuetify.breakpoint.mdAndUp) ? "7vw" :
                  (this.$vuetify.breakpoint.smAndUp) ? "20vw" : "64px"
        }
    }
}
</script>